export default "__VITE_ASSET__D2JCcw5$__"